var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7998 0C15.4567 0 16.7998 1.34315 16.7998 3V12.2725C16.7998 13.9293 15.4567 15.2725 13.7998 15.2725H3C1.34315 15.2725 0 13.9293 0 12.2725V3C0 1.34315 1.34315 7.35915e-09 3 0H13.7998ZM9.02539 1.52734C7.92082 1.52734 7.02539 2.42277 7.02539 3.52734V11.7451C7.02539 12.8497 7.92082 13.7451 9.02539 13.7451H13.1201C14.2246 13.745 15.1201 12.8496 15.1201 11.7451V3.52734C15.1201 2.42284 14.2246 1.52745 13.1201 1.52734H9.02539Z",
    fill: "#676E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCollapse);
export default __webpack_public_path__ + "static/media/SidebarCollapse.2433c0e07dad5cee850677e3eb6cb52a.svg";
export { ForwardRef as ReactComponent };